import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { isValidPhoneNumber } from "libphonenumber-js";

const schema = z
  .object({
    contact: z.string().trim().min(5).max(160),
    channel: z.enum(["email", "whatsapp"]).default("email"),
  })
  .superRefine((value, ctx) => {
    if (value.channel === "whatsapp") {
      if (!isValidPhoneNumber(value.contact)) {
        ctx.addIssue({ code: "custom", message: "invalid_phone", path: ["contact"] });
      }
      return;
    }
    if (!z.string().email().safeParse(value.contact).success && value.contact.length < 6) {
      ctx.addIssue({ code: "custom", message: "invalid_contact", path: ["contact"] });
    }
  });

export const requestGuide = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => schema.parse(input))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");

    // Doppelversand-Schutz: gleiche Adresse innerhalb 24 h nur einmal beliefern.
    let alreadySent = false;
    if (data.channel === "email") {
      const since = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();
      const { data: recent } = await supabaseAdmin
        .from("landing_leads")
        .select("id")
        .eq("contact", data.contact)
        .eq("source", "guide_email")
        .gte("created_at", since)
        .limit(1);
      alreadySent = Boolean(recent && recent.length > 0);
    }

    const { error } = await supabaseAdmin
      .from("landing_leads")
      .insert({ contact: data.contact, source: `guide_${data.channel}` });
    if (error) return { ok: false as const };

    if (data.channel === "email" && !alreadySent) {
      const [{ sendMail }, { renderGuideEmail }] = await Promise.all([
        import("@/lib/email.server"),
        import("@/lib/email/guide-email"),
      ]);
      const mail = renderGuideEmail();
      await sendMail({
        to: data.contact,
        subject: mail.subject,
        html: mail.html,
        text: mail.text,
      });
    }

    return { ok: true as const };
  });

